import {
  descriptionUI,
  titleUI,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import ToxicExposureDescription from '../../../../components/FormDescriptions/ToxicExposureDescription';
import content from '../../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../../utils/imports';

const TITLE_TEXT = content['service-info--toxic-exposure-title'];
const INPUT_LABEL = content['service-info--toxic-exposure-label'];

const { hasTeraResponse } = FULL_SCHEMA.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    ...descriptionUI(ToxicExposureDescription),
    hasTeraResponse: yesNoUI(INPUT_LABEL),
  },
  schema: {
    type: 'object',
    required: ['hasTeraResponse'],
    properties: { hasTeraResponse },
  },
};
